import { Icon } from '../UI';
import Checkout from '../../pages/Subscriptions/Checkout';
import { Modal } from '../Modal';
import React from 'react';
import { useAuth } from '../../context/Auth';

const CheckoutModal = ({ setIsModalOpen }) => {
  const { user } = useAuth();
  return (
    <Modal
      className="h-full w-full"
      handleMerlinLogo={true}
      customMerlinLogoColor={'#000000'}
      element={
        <div className={'flex flex-col w-full h-full bg-white'}>
          <div className={'h-16 bg-lime items-center flex justify-end p-4'}>
            <Icon
              className={'cursor-pointer'}
              svgName={'close'}
              onClick={() => setIsModalOpen(false)}
            />
          </div>
          <Checkout
            membershipPlanId={user?.membership.membershipPlan.id as string}
            action={'same'}
            setIsModalOpen={setIsModalOpen}
          />
        </div>
      }
      isFullScreenElement={true}
      isOpen={true}
    />
  );
};

export default CheckoutModal;
